import { render, staticRenderFns } from "./Cobros.vue?vue&type=template&id=40961554&lang=pug"
import script from "./Cobros.vue?vue&type=script&lang=js"
export * from "./Cobros.vue?vue&type=script&lang=js"
import style0 from "./Cobros.vue?vue&type=style&index=0&id=40961554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports